import React, { useState } from 'react'
import { Menu, MenuItem, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LabraToolTipV2 } from '@labrav/react-components'
import {
  faBars,
  faCircleQuestion,
  faGear,
  faWavePulse,
} from '@fortawesome/pro-regular-svg-icons'
import { helpDrawerUrl } from '../../../utils/constants'
import { useStyles } from './ChatMenu.styles'

const AGENT_SETTINGS_ROUTE = '/settings/funding'

interface ChatMenuProps {
  onAgentActivities?: () => void
}

export const ChatMenu: React.FC<ChatMenuProps> = ({ onAgentActivities }) => {
  const { classes, cx } = useStyles()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const closeMenu = () => setAnchorEl(null)

  return (
    <>
      <LabraToolTipV2 tooltipPlacement="bottom" description="Main menu">
        <button
          className={cx(classes.trigger, {
            [classes.triggerActive]: !!anchorEl,
          })}
          type="button"
          onClick={event => setAnchorEl(event.currentTarget)}
          aria-label="Main menu"
          aria-haspopup="menu"
          aria-expanded={!!anchorEl}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </LabraToolTipV2>

      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: { className: classes.paper, elevation: 0 },
          list: { className: classes.list },
        }}
      >
        {onAgentActivities && (
          <MenuItem
            className={classes.item}
            onClick={() => {
              closeMenu()
              onAgentActivities()
            }}
          >
            <span className={classes.itemIcon}>
              <FontAwesomeIcon icon={faWavePulse} />
            </span>
            <Typography className={classes.itemLabel}>
              Agent activities
            </Typography>
          </MenuItem>
        )}
        <MenuItem
          className={classes.item}
          onClick={() => {
            closeMenu()
            navigate(AGENT_SETTINGS_ROUTE)
          }}
        >
          <span className={classes.itemIcon}>
            <FontAwesomeIcon icon={faGear} />
          </span>
          <Typography className={classes.itemLabel}>Agent settings</Typography>
        </MenuItem>
        <MenuItem
          className={classes.item}
          onClick={() => {
            closeMenu()
            window.open(helpDrawerUrl, '_blank', 'noopener,noreferrer')
          }}
        >
          <span className={classes.itemIcon}>
            <FontAwesomeIcon icon={faCircleQuestion} />
          </span>
          <Typography className={classes.itemLabel}>Get help</Typography>
        </MenuItem>
      </Menu>
    </>
  )
}
